import { SIZE } from '../../constants';
export const TITLE_SIZE_MAP = {
    [SIZE.S]: 's',
    [SIZE.M]: 'm',
    [SIZE.L]: 'l',
};
export const DESCRIPTION_SIZE_MAP = {
    [SIZE.S]: 'm',
    [SIZE.M]: 'm',
    [SIZE.L]: 'l',
};
export const TRUNCATE_DEFAULTS = {
    title: 1,
    description: 2,
    metadata: 1,
};
